import { OverlayFileInfoSchema } from 'app/business-logic/domain-models/Blasting.schema';
import { LogManager } from 'core/logging/LogManager';
import { httpClient } from 'core/net/http';
import * as v from 'valibot';

const logger = LogManager.getLogger('deleteOverlayFile', { error: { logToServer: true } });

export const deleteOverlayFile = async (filename: string) => {
  const response = await httpClient.useInternalApi
    .asAuthorised()
    .delete('/configuration/blasting/scenarios/overlays', { filename });

  if (!response.isSuccess) {
    const errorMessage = `Failed to delete overlay file "${filename}"`;
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }

  const parsedData = v.safeParse(OverlayFileInfoSchema, response.data);

  if (!parsedData.success) {
    const errorMessage = `Failed to parse delete overlay file response for "${filename}"`;
    logger.error(errorMessage, parsedData.issues);
    throw new Error(errorMessage);
  }

  return parsedData.output;
};
